import {
  configureWebObservability,
  type WebObservability,
  type WebObservabilityOptions,
} from "@infinitaslearning/observability-web";
import type { Config } from "@/config";
import { name, version } from "../../../package.json";

const getObservabilityOptions = (environment: Config["ilEnv"]): WebObservabilityOptions => {
  const serviceName = name;
  const serviceVersion = version;
  const transactionSampleRate = 1;

  const serverUrl =
    environment === "local"
      ? "https://a2ccf4ce09324b819578f6253260eca7.apm.westeurope.azure.elastic-cloud.com:443"
      : undefined;
  const sendCredentials = environment === "local" ? false : undefined;
  const serverUrlPrefix = undefined;

  return {
    serviceName,
    serviceVersion,
    environment,
    serverUrl,
    serverUrlPrefix,
    sendCredentials,
    transactionSampleRate,
  };
};

export const observability = {
  start: (environment: Config["ilEnv"]): { apm: WebObservability } => {
    const options = getObservabilityOptions(environment);
    const apm: WebObservability | null = configureWebObservability(options);
    if (!apm) {
      throw new Error("Failed to initialize observability");
    }

    return { apm };
  },
};
